import PropTypes from 'prop-types'

export const ChatStatus = ({ type }) => {
  if (type === 'loading') {
    return (
      <div className="flex justify-start animate-fade-in">
        <div className="max-w-[85%] sm:max-w-[75%]">
          <div className="bg-dark-secondary px-4 py-3 rounded-2xl border border-dark-border">
            <div className="flex items-center space-x-1">
              <div
                className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                style={{ animationDelay: '0ms' }}
              />
              <div
                className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                style={{ animationDelay: '150ms' }}
              />
              <div
                className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                style={{ animationDelay: '300ms' }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return null
}

ChatStatus.propTypes = {
  type: PropTypes.oneOf(['loading', 'typing', 'error']).isRequired,
}

ChatStatus.defaultProps = {
  type: 'loading',
}
